import React, { useState, useEffect } from 'react';
import { Button, PopUp } from 'cantarus-react-ui';
import { ListManagerPopUpStrings as Strings } from '../../utils/config';
import FieldDataModel from '../FieldData/FieldDataModel'

const ListManagerPopUp = ({ show, togglePopUp, onAddListEntry, onEditListEntry, dataFields, dataModel, listManagerkey, isLayerPopUp }) => {

    const [dataModelToSave, setDataModelToSave] = useState(dataModel);
    const layeredClassName = isLayerPopUp ? 'layered' : ''

    useEffect(() => {
        setDataModelToSave(dataModel)
    }, [dataModel])

    const handleFieldDataChange = (index, newData) => {
        setDataModelToSave(newData);
    }

    const handleClose = () => {
        setDataModelToSave({})
        togglePopUp();
    }

    const handleSave = () => {
        dataModel ? onEditListEntry(listManagerkey, dataModelToSave) : onAddListEntry(dataModelToSave)
        handleClose();
    }

    const handleOutsideClick = () => {
        // Do nothing
    }

    return (
        <PopUp
            title={dataModel ? Strings.editTitle : Strings.addTitle}
            togglePopUp={handleOutsideClick}
            show={show}
            width="90%"
            classes={[layeredClassName, 'hide-x']}
        >
            <FieldDataModel modelKey={listManagerkey} dataFields={dataFields} initialDataModel={dataModel} onFieldDataChange={handleFieldDataChange} isPopUp />
            <hr />
            <div className='td-list-manager-pop-up-buttons'>
                <Button classes={['secondary']} text={Strings.cancelButton} onClick={handleClose} />
                <Button text={Strings.saveButton} onClick={handleSave} />
            </div>
        </PopUp>
    )
}

export default ListManagerPopUp;
